module.exports = __webpack_public_path__ + "img/59.8130289b.jpg";